import DashboardTemplate from "../components/templates/DashboardTemplate";

const Dashboard = () => {
    return <DashboardTemplate/>
};

export default Dashboard;